// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
export var data = {
    "Europe/Andorra": ["AD"],
    "Asia/Dubai": ["TF"],
    "Asia/Kabul": ["AF"],
    "America/Antigua": ["AG"],
    "America/Puerto_Rico": ["VI"],
    "America/Anguilla": ["AI"],
    "Europe/Tirane": ["AL"],
    "Asia/Yerevan": ["AM"],
    "Africa/Lagos": ["NG"],
    "Africa/Luanda": ["AO"],
    "Antarctica/Casey": ["AQ"],
    "Antarctica/Davis": ["AQ"],
    "Antarctica/DumontDUrville": ["AQ"],
    "Antarctica/Mawson": ["AQ"],
    "Antarctica/McMurdo": ["AQ"],
    "Antarctica/Palmer": ["AQ"],
    "Antarctica/Rothera": ["AQ"],
    "Antarctica/Syowa": ["AQ"],
    "Antarctica/Troll": ["AQ"],
    "Antarctica/Vostok": ["AQ"],
    "Asia/Riyadh": ["YE"],
    "Pacific/Auckland": ["NZ"],
    "Pacific/Port_Moresby": ["PG"],
    "America/Argentina/Buenos_Aires": ["AR"],
    "America/Argentina/Catamarca": ["AR"],
    "America/Argentina/Cordoba": ["AR"],
    "America/Argentina/Jujuy": ["AR"],
    "America/Argentina/La_Rioja": ["AR"],
    "America/Argentina/Mendoza": ["AR"],
    "America/Argentina/Rio_Gallegos": ["AR"],
    "America/Argentina/Salta": ["AR"],
    "America/Argentina/San_Juan": ["AR"],
    "America/Argentina/San_Luis": ["AR"],
    "America/Argentina/Tucuman": ["AR"],
    "America/Argentina/Ushuaia": ["AR"],
    "Pacific/Pago_Pago": ["UM"],
    "Europe/Vienna": ["AT"],
    "Antarctica/Macquarie": ["AU"],
    "Australia/Adelaide": ["AU"],
    "Australia/Brisbane": ["AU"],
    "Australia/Broken_Hill": ["AU"],
    "Australia/Darwin": ["AU"],
    "Australia/Eucla": ["AU"],
    "Australia/Hobart": ["AU"],
    "Australia/Lindeman": ["AU"],
    "Australia/Lord_Howe": ["AU"],
    "Australia/Melbourne": ["AU"],
    "Australia/Perth": ["AU"],
    "Australia/Sydney": ["AU"],
    "America/Aruba": ["AW"],
    "Europe/Helsinki": ["FI"],
    "Europe/Mariehamn": ["AX"],
    "Asia/Baku": ["AZ"],
    "Europe/Belgrade": ["SI"],
    "Europe/Sarajevo": ["BA"],
    "America/Barbados": ["BB"],
    "Asia/Dhaka": ["BD"],
    "Europe/Brussels": ["NL"],
    "Africa/Abidjan": ["TG"],
    "Africa/Ouagadougou": ["BF"],
    "Europe/Sofia": ["BG"],
    "Asia/Bahrain": ["BH"],
    "Asia/Qatar": ["QA"],
    "Africa/Bujumbura": ["BI"],
    "Africa/Maputo": ["ZW"],
    "Africa/Porto-Novo": ["BJ"],
    "America/St_Barthelemy": ["BL"],
    "Atlantic/Bermuda": ["BM"],
    "Asia/Brunei": ["BN"],
    "Asia/Kuching": ["MY"],
    "America/La_Paz": ["BO"],
    "America/Kralendijk": ["BQ"],
    "America/Araguaina": ["BR"],
    "America/Bahia": ["BR"],
    "America/Belem": ["BR"],
    "America/Boa_Vista": ["BR"],
    "America/Campo_Grande": ["BR"],
    "America/Cuiaba": ["BR"],
    "America/Eirunepe": ["BR"],
    "America/Fortaleza": ["BR"],
    "America/Maceio": ["BR"],
    "America/Manaus": ["BR"],
    "America/Noronha": ["BR"],
    "America/Porto_Velho": ["BR"],
    "America/Recife": ["BR"],
    "America/Rio_Branco": ["BR"],
    "America/Santarem": ["BR"],
    "America/Sao_Paulo": ["BR"],
    "America/Nassau": ["BS"],
    "America/Toronto": ["CA"],
    "Asia/Thimphu": ["BT"],
    "Africa/Gaborone": ["BW"],
    "Europe/Minsk": ["BY"],
    "America/Belize": ["BZ"],
    "America/Atikokan": ["CA"],
    "America/Blanc-Sablon": ["CA"],
    "America/Cambridge_Bay": ["CA"],
    "America/Creston": ["CA"],
    "America/Dawson": ["CA"],
    "America/Dawson_Creek": ["CA"],
    "America/Edmonton": ["CA"],
    "America/Fort_Nelson": ["CA"],
    "America/Glace_Bay": ["CA"],
    "America/Goose_Bay": ["CA"],
    "America/Halifax": ["CA"],
    "America/Inuvik": ["CA"],
    "America/Iqaluit": ["CA"],
    "America/Moncton": ["CA"],
    "America/Panama": ["PA"],
    "America/Phoenix": ["US"],
    "America/Rankin_Inlet": ["CA"],
    "America/Regina": ["CA"],
    "America/Resolute": ["CA"],
    "America/St_Johns": ["CA"],
    "America/Swift_Current": ["CA"],
    "America/Vancouver": ["CA"],
    "America/Whitehorse": ["CA"],
    "America/Winnipeg": ["CA"],
    "Asia/Yangon": ["MM"],
    "Indian/Cocos": ["CC"],
    "Africa/Kinshasa": ["CD"],
    "Africa/Lubumbashi": ["CD"],
    "Africa/Bangui": ["CF"],
    "Africa/Brazzaville": ["CG"],
    "Europe/Zurich": ["LI"],
    "Pacific/Rarotonga": ["CK"],
    "America/Punta_Arenas": ["CL"],
    "America/Santiago": ["CL"],
    "Pacific/Easter": ["CL"],
    "Africa/Douala": ["CM"],
    "Asia/Shanghai": ["CN"],
    "Asia/Urumqi": ["CN"],
    "America/Bogota": ["CO"],
    "America/Costa_Rica": ["CR"],
    "America/Havana": ["CU"],
    "Atlantic/Cape_Verde": ["CV"],
    "America/Curacao": ["CW"],
    "Asia/Bangkok": ["VN"],
    "Indian/Christmas": ["CX"],
    "Asia/Famagusta": ["CY"],
    "Asia/Nicosia": ["CY"],
    "Europe/Prague": ["SK"],
    "Europe/Berlin": ["SJ"],
    "Europe/Busingen": ["DE"],
    "Africa/Djibouti": ["DJ"],
    "Africa/Nairobi": ["YT"],
    "Europe/Copenhagen": ["DK"],
    "America/Dominica": ["DM"],
    "America/Santo_Domingo": ["DO"],
    "Africa/Algiers": ["DZ"],
    "America/Guayaquil": ["EC"],
    "Pacific/Galapagos": ["EC"],
    "Europe/Tallinn": ["EE"],
    "Africa/Cairo": ["EG"],
    "Africa/El_Aaiun": ["EH"],
    "Africa/Asmara": ["ER"],
    "Africa/Ceuta": ["ES"],
    "Atlantic/Canary": ["ES"],
    "Europe/Madrid": ["ES"],
    "Africa/Addis_Ababa": ["ET"],
    "Pacific/Fiji": ["FJ"],
    "Atlantic/Stanley": ["FK"],
    "Pacific/Chuuk": ["FM"],
    "Pacific/Guadalcanal": ["SB"],
    "Pacific/Kosrae": ["FM"],
    "Pacific/Pohnpei": ["FM"],
    "Atlantic/Faroe": ["FO"],
    "Europe/Paris": ["MC"],
    "Africa/Libreville": ["GA"],
    "Europe/London": ["JE"],
    "America/Grenada": ["GD"],
    "Asia/Tbilisi": ["GE"],
    "America/Cayenne": ["GF"],
    "Europe/Guernsey": ["GG"],
    "Africa/Accra": ["GH"],
    "Europe/Gibraltar": ["GI"],
    "America/Danmarkshavn": ["GL"],
    "America/Nuuk": ["GL"],
    "America/Scoresbysund": ["GL"],
    "America/Thule": ["GL"],
    "Africa/Banjul": ["GM"],
    "Africa/Conakry": ["GN"],
    "America/Guadeloupe": ["GP"],
    "Africa/Malabo": ["GQ"],
    "Europe/Athens": ["GR"],
    "Atlantic/South_Georgia": ["GS"],
    "America/Guatemala": ["GT"],
    "Pacific/Guam": ["MP"],
    "Africa/Bissau": ["GW"],
    "America/Guyana": ["GY"],
    "Asia/Hong_Kong": ["HK"],
    "America/Tegucigalpa": ["HN"],
    "Europe/Zagreb": ["HR"],
    "America/Port-au-Prince": ["HT"],
    "Europe/Budapest": ["HU"],
    "Asia/Jakarta": ["ID"],
    "Asia/Jayapura": ["ID"],
    "Asia/Makassar": ["ID"],
    "Asia/Pontianak": ["ID"],
    "Europe/Dublin": ["IE"],
    "Asia/Jerusalem": ["IL"],
    "Europe/Isle_of_Man": ["IM"],
    "Asia/Kolkata": ["IN"],
    "Indian/Chagos": ["IO"],
    "Asia/Baghdad": ["IQ"],
    "Asia/Tehran": ["IR"],
    "Atlantic/Reykjavik": ["IS"],
    "Europe/Rome": ["VA"],
    "Europe/Jersey": ["JE"],
    "America/Jamaica": ["JM"],
    "Asia/Amman": ["JO"],
    "Asia/Tokyo": ["JP"],
    "Asia/Bishkek": ["KG"],
    "Asia/Phnom_Penh": ["KH"],
    "Pacific/Kanton": ["KI"],
    "Pacific/Kiritimati": ["KI"],
    "Pacific/Tarawa": ["WF"],
    "Indian/Comoro": ["KM"],
    "America/St_Kitts": ["KN"],
    "Asia/Pyongyang": ["KP"],
    "Asia/Seoul": ["KR"],
    "Asia/Kuwait": ["KW"],
    "America/Cayman": ["KY"],
    "Asia/Almaty": ["KZ"],
    "Asia/Aqtau": ["KZ"],
    "Asia/Aqtobe": ["KZ"],
    "Asia/Atyrau": ["KZ"],
    "Asia/Oral": ["KZ"],
    "Asia/Qostanay": ["KZ"],
    "Asia/Qyzylorda": ["KZ"],
    "Asia/Vientiane": ["LA"],
    "Asia/Beirut": ["LB"],
    "America/St_Lucia": ["LC"],
    "Europe/Vaduz": ["LI"],
    "Asia/Colombo": ["LK"],
    "Africa/Monrovia": ["LR"],
    "Africa/Johannesburg": ["ZA"],
    "Africa/Maseru": ["LS"],
    "Europe/Vilnius": ["LT"],
    "Europe/Luxembourg": ["LU"],
    "Europe/Riga": ["LV"],
    "Africa/Tripoli": ["LY"],
    "Africa/Casablanca": ["MA"],
    "Europe/Monaco": ["MC"],
    "Europe/Chisinau": ["MD"],
    "Europe/Podgorica": ["ME"],
    "America/Marigot": ["MF"],
    "Indian/Antananarivo": ["MG"],
    "Pacific/Kwajalein": ["MH"],
    "Pacific/Majuro": ["MH"],
    "Europe/Skopje": ["MK"],
    "Africa/Bamako": ["ML"],
    "Asia/Choibalsan": ["MN"],
    "Asia/Hovd": ["MN"],
    "Asia/Ulaanbaatar": ["MN"],
    "Asia/Macau": ["MO"],
    "Pacific/Saipan": ["MP"],
    "America/Martinique": ["MQ"],
    "Africa/Nouakchott": ["MR"],
    "America/Montserrat": ["MS"],
    "Europe/Malta": ["MT"],
    "Indian/Mauritius": ["MU"],
    "Indian/Maldives": ["TF"],
    "Africa/Blantyre": ["MW"],
    "America/Bahia_Banderas": ["MX"],
    "America/Cancun": ["MX"],
    "America/Chihuahua": ["MX"],
    "America/Ciudad_Juarez": ["MX"],
    "America/Hermosillo": ["MX"],
    "America/Matamoros": ["MX"],
    "America/Mazatlan": ["MX"],
    "America/Merida": ["MX"],
    "America/Mexico_City": ["MX"],
    "America/Monterrey": ["MX"],
    "America/Ojinaga": ["MX"],
    "America/Tijuana": ["MX"],
    "Asia/Kuala_Lumpur": ["MY"],
    "Asia/Singapore": ["SG"],
    "Africa/Windhoek": ["NA"],
    "Pacific/Noumea": ["NC"],
    "Africa/Niamey": ["NE"],
    "Pacific/Norfolk": ["NF"],
    "America/Managua": ["NI"],
    "Europe/Amsterdam": ["NL"],
    "Europe/Oslo": ["NO"],
    "Asia/Kathmandu": ["NP"],
    "Pacific/Nauru": ["NR"],
    "Pacific/Niue": ["NU"],
    "Pacific/Chatham": ["NZ"],
    "Asia/Muscat": ["OM"],
    "America/Lima": ["PE"],
    "Pacific/Gambier": ["PF"],
    "Pacific/Marquesas": ["PF"],
    "Pacific/Tahiti": ["PF"],
    "Pacific/Bougainville": ["PG"],
    "Asia/Manila": ["PH"],
    "Asia/Karachi": ["PK"],
    "Europe/Warsaw": ["PL"],
    "America/Miquelon": ["PM"],
    "Pacific/Pitcairn": ["PN"],
    "Asia/Gaza": ["PS"],
    "Asia/Hebron": ["PS"],
    "Atlantic/Azores": ["PT"],
    "Atlantic/Madeira": ["PT"],
    "Europe/Lisbon": ["PT"],
    "Pacific/Palau": ["PW"],
    "America/Asuncion": ["PY"],
    "Indian/Reunion": ["RE"],
    "Europe/Bucharest": ["RO"],
    "Asia/Anadyr": ["RU"],
    "Asia/Barnaul": ["RU"],
    "Asia/Chita": ["RU"],
    "Asia/Irkutsk": ["RU"],
    "Asia/Kamchatka": ["RU"],
    "Asia/Khandyga": ["RU"],
    "Asia/Krasnoyarsk": ["RU"],
    "Asia/Magadan": ["RU"],
    "Asia/Novokuznetsk": ["RU"],
    "Asia/Novosibirsk": ["RU"],
    "Asia/Omsk": ["RU"],
    "Asia/Sakhalin": ["RU"],
    "Asia/Srednekolymsk": ["RU"],
    "Asia/Tomsk": ["RU"],
    "Asia/Ust-Nera": ["RU"],
    "Asia/Vladivostok": ["RU"],
    "Asia/Yakutsk": ["RU"],
    "Asia/Yekaterinburg": ["RU"],
    "Europe/Astrakhan": ["RU"],
    "Europe/Kaliningrad": ["RU"],
    "Europe/Kirov": ["RU"],
    "Europe/Moscow": ["RU"],
    "Europe/Samara": ["RU"],
    "Europe/Saratov": ["RU"],
    "Europe/Simferopol": ["UA"],
    "Europe/Ulyanovsk": ["RU"],
    "Europe/Volgograd": ["RU"],
    "Africa/Kigali": ["RW"],
    "Indian/Mahe": ["SC"],
    "Africa/Khartoum": ["SD"],
    "Europe/Stockholm": ["SE"],
    "Atlantic/St_Helena": ["SH"],
    "Europe/Ljubljana": ["SI"],
    "Arctic/Longyearbyen": ["SJ"],
    "Europe/Bratislava": ["SK"],
    "Africa/Freetown": ["SL"],
    "Europe/San_Marino": ["SM"],
    "Africa/Dakar": ["SN"],
    "Africa/Mogadishu": ["SO"],
    "America/Paramaribo": ["SR"],
    "Africa/Juba": ["SS"],
    "Africa/Sao_Tome": ["ST"],
    "America/El_Salvador": ["SV"],
    "America/Lower_Princes": ["SX"],
    "Asia/Damascus": ["SY"],
    "Africa/Mbabane": ["SZ"],
    "America/Grand_Turk": ["TC"],
    "Africa/Ndjamena": ["TD"],
    "Indian/Kerguelen": ["TF"],
    "Africa/Lome": ["TG"],
    "Asia/Dushanbe": ["TJ"],
    "Pacific/Fakaofo": ["TK"],
    "Asia/Dili": ["TL"],
    "Asia/Ashgabat": ["TM"],
    "Africa/Tunis": ["TN"],
    "Pacific/Tongatapu": ["TO"],
    "Europe/Istanbul": ["TR"],
    "America/Port_of_Spain": ["TT"],
    "Pacific/Funafuti": ["TV"],
    "Asia/Taipei": ["TW"],
    "Africa/Dar_es_Salaam": ["TZ"],
    "Europe/Kyiv": ["UA"],
    "Africa/Kampala": ["UG"],
    "Pacific/Midway": ["UM"],
    "Pacific/Wake": ["UM"],
    "America/Adak": ["US"],
    "America/Anchorage": ["US"],
    "America/Boise": ["US"],
    "America/Chicago": ["US"],
    "America/Denver": ["US"],
    "America/Detroit": ["US"],
    "America/Indiana/Indianapolis": ["US"],
    "America/Indiana/Knox": ["US"],
    "America/Indiana/Marengo": ["US"],
    "America/Indiana/Petersburg": ["US"],
    "America/Indiana/Tell_City": ["US"],
    "America/Indiana/Vevay": ["US"],
    "America/Indiana/Vincennes": ["US"],
    "America/Indiana/Winamac": ["US"],
    "America/Juneau": ["US"],
    "America/Kentucky/Louisville": ["US"],
    "America/Kentucky/Monticello": ["US"],
    "America/Los_Angeles": ["US"],
    "America/Menominee": ["US"],
    "America/Metlakatla": ["US"],
    "America/New_York": ["US"],
    "America/Nome": ["US"],
    "America/North_Dakota/Beulah": ["US"],
    "America/North_Dakota/Center": ["US"],
    "America/North_Dakota/New_Salem": ["US"],
    "America/Sitka": ["US"],
    "America/Yakutat": ["US"],
    "Pacific/Honolulu": ["US"],
    "America/Montevideo": ["UY"],
    "Asia/Samarkand": ["UZ"],
    "Asia/Tashkent": ["UZ"],
    "Europe/Vatican": ["VA"],
    "America/St_Vincent": ["VC"],
    "America/Caracas": ["VE"],
    "America/Tortola": ["VG"],
    "America/St_Thomas": ["VI"],
    "Asia/Ho_Chi_Minh": ["VN"],
    "Pacific/Efate": ["VU"],
    "Pacific/Wallis": ["WF"],
    "Pacific/Apia": ["WS"],
    "Asia/Aden": ["YE"],
    "Indian/Mayotte": ["YT"],
    "Africa/Lusaka": ["ZM"],
    "Africa/Harare": ["ZW"],
};
